module.exports = __webpack_public_path__ + "img/2.a8f781eb.svg";